import React from "react";
import { useTranslation } from "react-i18next";

import { DataTransferModal } from "../valuationReportPage/DataTransferModal";

type WithRouteMeta = {
  isUnprotected?: boolean;
};

const ValuationError: React.FC = () => {
  const { t } = useTranslation();

  return (
    <DataTransferModal
      open={true}
      isDataLoading={false}
      isError={true}
      error={{
        header: t("errors.loginError.title"),
        text: t("errors.loginError.text"),
      }}
    />
  );
};

export const ValuationErrorPage = ValuationError as React.FC & WithRouteMeta;
ValuationErrorPage.isUnprotected = true;
